export const SET_STATUS = 'SET_STATUS';
export const REMOVE_TASK = 'REMOVE_TASK';
export const ADD_ITEM = 'ADD_ITEM';
export const ADD_TASK = 'ADD_TASK';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const EDIT_ITEM_NAME = 'EDIT_ITEM_NAME';
export const EDIT_TASK_TITLE = 'EDIT_TASK_TITLE';
export const EDIT_TASK_DURATION = 'EDIT_TASK_DURATION';
export const ACTIVATE_TASK = 'ACTIVATE_TASK';
export const DEACTIVATE_TASK = 'DEACTIVATE_TASK';